import { useCurrentInstanceId } from "./useInstanceId";

export function useHasInstance(): boolean {
  const { instanceId } = useCurrentInstanceId();
  return (instanceId ?? "").trim() !== "";
}
